import { React, Component, Container, _ } from 'utils';
import { Campaigns, Creators } from 'model'
import './move-to-campaign.less';
import SelectableCampaign from './SelectableCampaign';

class MoveToCampaing extends Component {

	static getStores() {
		return [Campaigns];
	}

	static calculateState() {
		var state = Campaigns.getState();

		return {
			campaigns: state.campaigns,
			selected: state.selected,
			filter: state.filter
		}
	}

	handleChange = (event) => {
		Creators.folderFilterChanged(event.target.value);
	}

	handleSelect = (campaign) => {
		Creators.campaignSelected(campaign);
	}

	handleNewCampaign = (event) => {
		Creators.hideFolders();
		Creators.createCampaign();
	}
	
	render() {
		const { campaigns, selected, filter } = this.state;

		const vCampaigns = campaigns
			.filter((campaign) => {
				const title = campaign.title.toLocaleLowerCase();
				const filterText = filter.toLocaleLowerCase();
				return title.indexOf(filterText) !== -1;
			})
			.map((campaign, index) => (
				<SelectableCampaign
					key={campaign.id}
					campaign={ campaign }
					selected={selected != null && campaign.id == selected.id}
					onSelect={this.handleSelect}
				/>
			)
		);

		return (
			<div className="move-to-campaign">
				<div className="search-box">
					<i className="fa fa-search"></i>
					<input className="folder-search" type="text" value={filter}
						onChange={this.handleChange} className="form-control" />
				</div>
				{ vCampaigns }
			</div>
		);
	}
}

const container = Container.create(MoveToCampaing);
export default container;


// WEBPACK FOOTER //
// ./src/modules/campaign/MoveToCampaign.js